import { ReactNode, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { enqueueSnackbar, OptionsWithExtraProps } from 'notistack';

export function useNotification() {
  const intl = useIntl();

  return {
    showError: useCallback((message: ReactNode, options?: OptionsWithExtraProps<'error'>) => {
      enqueueSnackbar(message, {
        variant: 'error',
        ...options,
      });
    }, []),
    showErrorIntl: useCallback((message: string, options?: OptionsWithExtraProps<'error'>) => {
      enqueueSnackbar(intl.formatMessage({ id: message }), {
        variant: 'error',
        ...options,
      });
    }, []),
    showSuccess: useCallback((message: ReactNode, options?: OptionsWithExtraProps<'success'>) => {
      enqueueSnackbar(message, {
        variant: 'success',
        ...options,
      });
    }, []),
    showSuccessIntl: useCallback((message: string, options?: OptionsWithExtraProps<'success'>) => {
      enqueueSnackbar(intl.formatMessage({ id: message }), {
        variant: 'success',
        ...options,
      });
    }, []),
    showInfo: useCallback((message: ReactNode, options?: OptionsWithExtraProps<'info'>) => {
      enqueueSnackbar(message, {
        variant: 'info',
        ...options,
      });
    }, []),
    showInfoIntl: useCallback((message: string, options?: OptionsWithExtraProps<'info'>) => {
      enqueueSnackbar(intl.formatMessage({ id: message }), {
        variant: 'info',
        ...options,
      });
    }, []),
    showNote: useCallback((message: ReactNode, options?: OptionsWithExtraProps<'info'>) => {
      enqueueSnackbar(message, {
        variant: 'info',
        style: { opacity: 0.5 },
        ...options,
      });
    }, []),
    showNoteIntl: useCallback((message: string, options?: OptionsWithExtraProps<'info'>) => {
      enqueueSnackbar(intl.formatMessage({ id: message }), {
        variant: 'info',
        style: { opacity: 0.5 },
        ...options,
      });
    }, []),
  };
}
